<div
  class="bfx__library__toggle__switch container-outer"
  [class.selected]="checked"
  [class.disabled]="disabled"
  [class.enabled]="!disabled"
  role="switch"
  tabindex="0"
  [attr.aria-checked]="checked"
>
  <div
    class="track"
    [class.disabled]="disabled"
    [class.enabled]="!disabled"
    [class.bold]="bold"
    [class.subtle]="!bold"
    [class.selected]="checked"
    [class.lg]="size == 'large'"
    [class.sm]="size == 'small'"
    [class.md]="size == 'medium'"
  >
    <div class="container-inner" [class.selected]="checked">
      <div
        class="handle"
        [class.disabled]="disabled"
        [class.enabled]="!disabled"
        [class.selected]="checked"
        [class.bold]="bold"
        [class.subtle]="!bold"
        [class.lg]="size == 'large'"
        [class.sm]="size == 'small'"
        [class.md]="size == 'medium'"
      ></div>
    </div>
  </div>
</div>
